import type { ReactNode } from 'react';
import { OutcomeDrawer } from '../../OutcomeDrawer.js';
import { useAlisonRun } from '../AlisonRunProvider.js';

// The real outcome drawer, opened over the run: closing it shows the run still going.
export function AlisonOutcomeLayer(): ReactNode {
  const { peekActionType, rows, session, setup, peek } = useAlisonRun();
  const outcome = rows.find((row) => row.actionType === peekActionType)?.outcome ?? null;
  if (outcome === null) return null;
  return (
    <OutcomeDrawer
      outcome={outcome}
      scope={session?.scope ?? null}
      leadingKpi={setup?.leadingKpi ?? ''}
      onClose={() => peek(null)}
    />
  );
}
